import { render, staticRenderFns } from "./other_sns.vue?vue&type=template&id=6cf41c97&"
import script from "./other_sns.vue?vue&type=script&lang=js&"
export * from "./other_sns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports